import React from "react";
import styles from "./AboutGallerySection.module.scss";
import galleryImage from "../../../assets/images/gallery-image.jpg";
import ReactReadMoreReadLess from "react-read-more-read-less";
import LocationIcon from "components/svgs/LocationIcon";
import PhoneIcon from "components/svgs/PhoneIcon";
import EnvelopeIcon from "components/svgs/EnvelopeIcon";
import InternetIcon from "components/svgs/InternetIcon";

const AboutGallerySection = () => {
  return (
    <div className={`aboutRef ${styles.aboutGallerySectionContainer}`}>
      <div className="container">
        <div className={styles.galleryGrid}>
          <div
            className={styles.card}
            onClick={() => console.log("Card clicked.")}
          >
            <div className={styles.mainImage}>
              <img src={galleryImage} alt="Gallery Name" />
            </div>
            <div className={styles.otherImages}>
              <div>
                <img src={galleryImage} alt="Gallery Name" />
              </div>
              <div>
                <img src={galleryImage} alt="Gallery Name" />
              </div>
              <div>
                <img src={galleryImage} alt="Gallery Name" />
              </div>
            </div>
          </div>
          <div className={styles.info}>
            <div className={styles.row}>Date of Foundation: 1992</div>
            <div className={styles.row}>
              <LocationIcon />
              Armenia, Yerevan, Tumanyan Street 13
            </div>
            <div className={styles.row}>
              <PhoneIcon />
              +374 55 357656
            </div>
            <div className={styles.row}>
              <EnvelopeIcon />
              galleryname@gmail.com
            </div>
            <div className={styles.row}>
              <InternetIcon />
              www.gallerryname.com
            </div>
            <p className={styles.desc}>
              <ReactReadMoreReadLess
                charLimit={200}
                readMoreText={"Read more ▼"}
                readLessText={"Read less ▲"}
              >
                Where does it come from? Contrary to popular belief, Lorem Ipsum
                is not simply random text. It has roots in a piece of classical
                Latin literature from 45 BC, making it over 2000 years old.
                Richard McClintock, a Latin professor at Hampden-Sydney College
                in Virginia, looked up one of the more obscure Latin words,
                consectetur, from a Lorem Ipsum passage, and going through the
                cites of the word in
              </ReactReadMoreReadLess>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutGallerySection;
